let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aJ6oi")).then(() => parcelRequire('6Ivy0'));